import React from 'react';

export type FABActionKey = string;

export interface FABActionDef {
  key: string;
  label: string;
  icon: React.ReactNode;
  roles: ('dominant' | 'submissive' | 'switch')[];
}

// ─── Inline SVG Icons ─────────────────────────────────────────────────────────

const TaskIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('path', { d: 'M9 11l3 3L22 4' }),
  React.createElement('path', { d: 'M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11' })
);

const HeartIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('path', {
    d: 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z',
  })
);

const CheckOnSubIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('circle', { cx: '10', cy: '8', r: '3.5' }),
  React.createElement('path', { d: 'M3.5 20c0-3.6 2.9-6.5 6.5-6.5 1.1 0 2.1.3 3 .7' }),
  React.createElement('circle', { cx: '17', cy: '16', r: '3' }),
  React.createElement('path', { d: 'M19.2 18.2L22 21' })
);

const MessageIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('path', { d: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' })
);

const ChecklistIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('path', { d: 'M3 5l2 2 3-3' }),
  React.createElement('path', { d: 'M3 12l2 2 3-3' }),
  React.createElement('path', { d: 'M3 19l2 2 3-3' }),
  React.createElement('line', { x1: '12', y1: '5', x2: '21', y2: '5' }),
  React.createElement('line', { x1: '12', y1: '12', x2: '21', y2: '12' }),
  React.createElement('line', { x1: '12', y1: '19', x2: '21', y2: '19' })
);

const JournalIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('path', { d: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20' }),
  React.createElement('path', { d: 'M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z' }),
  React.createElement('line', { x1: '8', y1: '7', x2: '16', y2: '7' }),
  React.createElement('line', { x1: '8', y1: '11', x2: '13', y2: '11' })
);

const SmileIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('circle', { cx: '12', cy: '12', r: '10' }),
  React.createElement('path', { d: 'M8 14s1.5 2 4 2 4-2 4-2' }),
  React.createElement('line', { x1: '9', y1: '9', x2: '9.01', y2: '9' }),
  React.createElement('line', { x1: '15', y1: '9', x2: '15.01', y2: '9' })
);

const ClockIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('circle', { cx: '12', cy: '12', r: '10' }),
  React.createElement('polyline', { points: '12 6 12 12 16 14' })
);

const ShieldIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' })
);

const PhoneIcon: React.ReactNode = React.createElement(
  'svg',
  {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true',
  },
  React.createElement('path', {
    d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z',
  })
);

// ─── Registry ──────────────────────────────────────────────────────────────────

export const FAB_ACTION_REGISTRY: Record<string, FABActionDef> = {
  // Dominant actions
  assign_task: {
    key: 'assign_task',
    label: 'Assign Task',
    icon: TaskIcon,
    roles: ['dominant', 'switch'],
  },
  send_praise: {
    key: 'send_praise',
    label: 'Send Praise',
    icon: HeartIcon,
    roles: ['dominant', 'switch'],
  },
  check_on_sub: {
    key: 'check_on_sub',
    label: 'Check on Sub',
    icon: CheckOnSubIcon,
    roles: ['dominant', 'switch'],
  },
  quick_message: {
    key: 'quick_message',
    label: 'Quick Message',
    icon: MessageIcon,
    roles: ['dominant', 'switch'],
  },
  // Submissive actions
  view_tasks: {
    key: 'view_tasks',
    label: 'My Tasks',
    icon: ChecklistIcon,
    roles: ['submissive', 'switch'],
  },
  journal_entry: {
    key: 'journal_entry',
    label: 'Journal',
    icon: JournalIcon,
    roles: ['submissive', 'switch'],
  },
  check_in: {
    key: 'check_in',
    label: 'Check In',
    icon: SmileIcon,
    roles: ['submissive', 'switch'],
  },
  message_dom: {
    key: 'message_dom',
    label: 'Message Dom',
    icon: MessageIcon,
    roles: ['submissive', 'switch'],
  },
  // Safety-route actions (CEO 2026-10-13): used only by the rail on safety routes, never offered in the
  // customize picker. Deliberately no safeword trigger there: a stray tap would alert people.
  safety_timer: {
    key: 'safety_timer',
    label: 'Start check-in timer',
    icon: ClockIcon,
    roles: ['dominant', 'submissive', 'switch'],
  },
  safety_hub: {
    key: 'safety_hub',
    label: 'Safety hub',
    icon: ShieldIcon,
    roles: ['dominant', 'submissive', 'switch'],
  },
  crisis_lines: {
    key: 'crisis_lines',
    label: 'Crisis lines',
    icon: PhoneIcon,
    roles: ['dominant', 'submissive', 'switch'],
  },
};

/**
 * The rail's three slots on safety routes, for a given identity. Ignores saved preferences. Slot 0 is the check-in
 * timer only when the emergencyTimer feature is on (the server gates /check-in/start on it); otherwise the Safety hub.
 */
export function safetyRouteActionKeys(identity: string | null | undefined, timerEnabled: boolean): [string, string, string] {
  return [timerEnabled ? 'safety_timer' : 'safety_hub', identity === 'dominant' ? 'check_on_sub' : 'message_dom', 'crisis_lines'];
}

// ─── Role defaults ─────────────────────────────────────────────────────────────

export const DOM_DEFAULTS: FABActionKey[] = ['assign_task', 'send_praise', 'check_on_sub'];
export const SUB_DEFAULTS: FABActionKey[] = ['view_tasks', 'journal_entry', 'check_in'];
export const SWITCH_DEFAULTS: FABActionKey[] = ['view_tasks', 'check_in', 'journal_entry'];
